import { ref } from "vue";

const STORAGE_KEY = "toasthost-view-as-member";

function getInitial(): boolean {
  if (typeof window === "undefined") return false;
  try {
    return window.localStorage.getItem(STORAGE_KEY) === "true";
  } catch {
    return false;
  }
}

function persist(value: boolean) {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(STORAGE_KEY, String(value));
  } catch {
    // Ignore storage failures (private mode, quota, etc.)
  }
}

export const isViewAsMemberEnabled = ref<boolean>(getInitial());

// Shared "you were bounced off an officer page because member view is on" notice
// state. Set from two places: the router auth guard (when navigating to /
// bookmarking a gated route while the masked role lacks access) and MainLayout's
// flag-flip watcher (when member view is enabled while already on a gated page).
// MainLayout renders the snackbar bound to this ref. It lives here, not in
// MainLayout, so the guard — which runs before the layout sees the gated route —
// can trigger it too.
const memberViewRedirectNotice = ref<boolean>(false);

export function setViewAsMember(value: boolean) {
  isViewAsMemberEnabled.value = value;
  persist(value);
  // Exiting member view makes any "tools hidden" notice moot.
  if (!value) memberViewRedirectNotice.value = false;
}

export function toggleViewAsMember() {
  setViewAsMember(!isViewAsMemberEnabled.value);
}

export function notifyMemberViewRedirect() {
  if (isViewAsMemberEnabled.value) memberViewRedirectNotice.value = true;
}

export function useViewAsMember() {
  return {
    isViewAsMemberEnabled,
    memberViewRedirectNotice,
    setViewAsMember,
    toggleViewAsMember,
    notifyMemberViewRedirect,
  };
}
